import {
  WORLD_WIDTH, WORLD_HEIGHT, PLAYER_SIZE, PLAYER_SPEED,
  DASH_DISTANCE, DASH_DURATION, ROCK_COLLISION_SCALE,
} from '../../../constants';
import { resolveRectOverlap } from '../helpers';

export function updatePlayerMovement(s, dt, timestamp) {
  // ── Dash end check ──────────────────────────────────────────────────────
  if (s.isDashing && timestamp >= s.dashEndTime) s.isDashing = false;

  const { player } = s;

  if (s.isDashing) {
    const dashSpeed = DASH_DISTANCE / (DASH_DURATION / 1000);
    player.x = Math.max(0, Math.min(WORLD_WIDTH  - PLAYER_SIZE, player.x + s.dashVelX * dashSpeed * dt));
    player.y = Math.max(0, Math.min(WORLD_HEIGHT - PLAYER_SIZE, player.y + s.dashVelY * dashSpeed * dt));
    s.velocity.x = 0;
    s.velocity.y = 0;
  } else {
    const effectiveSpeedMult = Math.sqrt(s.speedMult);
    const spd = PLAYER_SPEED * effectiveSpeedMult * (s.activeModifier?.playerSpeedMult ?? 1) * (s.pondSlowFactor ?? 1);

    const { keys } = s;
    const arrowVx = (keys['arrowright'] ? 1 : 0) - (keys['arrowleft'] ? 1 : 0);
    const arrowVy = (keys['arrowdown']  ? 1 : 0) - (keys['arrowup']   ? 1 : 0);
    let targetVx = arrowVx * spd;
    let targetVy = arrowVy * spd;

    if (s.mouse.down && arrowVx === 0 && arrowVy === 0) {
      const px = player.x + PLAYER_SIZE / 2;
      const py = player.y + PLAYER_SIZE / 2;
      const dx = s.mouse.x - px;
      const dy = s.mouse.y - py;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist > 4) { targetVx = (dx / dist) * spd; targetVy = (dy / dist) * spd; }
    }

    s.velocity.x += (targetVx - s.velocity.x) * 0.15;
    s.velocity.y += (targetVy - s.velocity.y) * 0.15;
    if (Math.abs(s.velocity.x) < 0.02) s.velocity.x = 0;
    if (Math.abs(s.velocity.y) < 0.02) s.velocity.y = 0;
    player.x = Math.max(0, Math.min(WORLD_WIDTH  - PLAYER_SIZE, player.x + s.velocity.x));
    player.y = Math.max(0, Math.min(WORLD_HEIGHT - PLAYER_SIZE, player.y + s.velocity.y));
  }

  // ── Facing direction & walk animation ───────────────────────────────────
  const vx = s.isDashing ? s.dashVelX : s.velocity.x;
  const vy = s.isDashing ? s.dashVelY : s.velocity.y;
  const speed = Math.hypot(vx, vy);
  if (speed > 0.05) {
    s.playerIsMoving    = true;
    s.playerFacingAngle = Math.atan2(vy, vx) + Math.PI / 2;
    const frameInterval = Math.max(80, Math.min(300, 300 / speed));
    if (timestamp - (s.playerFrameLastToggle ?? 0) >= frameInterval) {
      s.playerFrame = 1 - (s.playerFrame ?? 0);
      s.playerFrameLastToggle = timestamp;
    }
  } else {
    s.playerIsMoving = false;
    s.playerFrame    = 0;
  }
}

export function resolvePlayerRockCollisions(s) {
  const { player } = s;
  for (const rock of s.rocks) {
    // Shrink the collision box to match the visible CSS-clipped rock shape.
    const colSize = rock.size * ROCK_COLLISION_SCALE;
    const offset  = (rock.size - colSize) / 2;
    const colRock = { x: rock.x + offset, y: rock.y + offset };
    resolveRectOverlap(player, colRock, PLAYER_SIZE, colSize);
    player.x = Math.max(0, Math.min(WORLD_WIDTH  - PLAYER_SIZE, player.x));
    player.y = Math.max(0, Math.min(WORLD_HEIGHT - PLAYER_SIZE, player.y));
  }
}
